<!--
<div
  class="card-white portfolio-item bordeblue"
  [ngClass]="{
    'not-pointer': !item.PortfolioHaveComponents,
    pointer: enableClick
  }"
  (click)="openPortfolio()"
  [class.hover-enabled]="enableHover"
>
  <div class="header borde" [ngClass]="{ headerFlex: !iconPortfolio }">
    <tech-back
      [direction]="'/portfolios'"
      *ngIf="showBack"
      class="back"
    ></tech-back>

    <div class="logoname" [ngClass]="{ hidden: !iconPortfolio }">
      {{ item.Alias ? item.Alias.substring(0, 2).toUpperCase() : '' }}
    </div>
    <div class="label-wrapper">
      <span class="label">{{ item.Alias }}</span>
      <span class="sublabel modelo"
        >{{ item.ServiceModelName ? item.ServiceModelName : '-' }}
      </span>
    </div>
    <div>
      <fa-icon
      *ngIf="!isProfileportfolio"
      [icon]="['fas', 'chevron-right']"
      class="fa-lg colorright"
      ></fa-icon>
    </div>
  </div>
  <div class="body">
    <div class="titulocantidad">
      {{ 'k004385' | translate }}
    </div>
    <div class="cantidad">
      {{ item.Valuation | trCurrency : item.Currency }}
    </div>
    <div class="beneficio">
      <div class="textito">{{ 'k004390' | translate }}
         <fa-icon
            class="ml-1 pointer blue2"
            icon="info-circle"
            (click)="viewHintHelp($event); $event.stopPropagation()"
          ></fa-icon>
      </div>
      <div>
        <div class="ben-valor">
          <span>
          {{
            item.ProfitLoss == -10000
              ? '-'
              : (item.ProfitLoss | trCurrency : item.Currency)
          }}
          </span>
          <span>({{ item.TotalProfitLossBeetweenDatesPercent | trPercentSignus }})</span>
        </div>
      </div>
    </div>
    <div class="version" *ngIf="!isMovil">
      {{ 'k003231' | translate }}:
      {{ item.ValuationDate | date : dateFormat }}
    </div>
  </div>
  <div class="footer">
    <div class="item">
      <button
        class="card"
        mat-flat-button
        (click)="
          reportWithDate
            ? openDialog(item, $event)
            : openPdf(
                item.PortfolioCode,
                item.InitialDate,
                item.AnalysisDate,
                $event
              )
        "
      >
        <fa-icon class="imgs" [icon]="['fal', 'file-chart-line']"></fa-icon>
      </button>

      <span class="label">{{ 'k000067' | translate }}</span>
    </div>

    <div class="item" *ngIf="item.AllowOperations.VisibleContribution">
      <button class="card" mat-flat-button (click)="goAportacion($event)">
        <fa-icon
          *ngIf="!item.AllowOperations.AllowContribution"
          class="warning infowarning"
          [icon]="['fas', 'exclamation-circle']"
        ></fa-icon>
        <fa-icon class="imgs" rotate="90" [icon]="['fal', 'sign-in']"></fa-icon>
      </button>
      <span class="label">{{ 'k000521' | translate }}</span>
    </div>

    <div class="item" *ngIf="item.AllowOperations.VisibleWithdrawal">
      <button class="card" mat-flat-button (click)="goRembolso($event)">
        <fa-icon
          *ngIf="!item.AllowOperations.AllowWithdrawal"
          class="warning infowarning"
          [icon]="['fas', 'exclamation-circle']">
        </fa-icon>
        <fa-icon
          class="imgs"
          rotate="270"
          [icon]="['fal', 'sign-out']">
        </fa-icon>
      </button>
      <span class="label">{{ 'k000139' | translate }}</span>
    </div>
  </div>
</div>
-->
<!--New-->
<div
  class="card-white portfolio-item bordeblue"
  [ngClass]="{
    'not-pointer': !item.PortfolioHaveComponents,
    pointer: enableClick
  }"
  (click)="openPortfolio()"
>
  <div class="header borde" [ngClass]="{ headerFlex: !iconPortfolio }">
    <tech-back
      [direction]="'/portfolios'"
      *ngIf="showBack"
      class="back"
    ></tech-back>

    <div class="logoname" [ngClass]="{ hidden: !iconPortfolio }">
      {{ item.Alias ? item.Alias.substring(0, 2).toUpperCase() : '' }}
    </div>
    <div class="label-wrapper">
      <span class="label">{{ item.Alias }}</span>
      <span class="sublabel modelo"
        >{{ item.ServiceModelName ? item.ServiceModelName : '-' }}
      </span>
    </div>
  </div>
    <div class="body">
    <div class="titulocantidad">
      {{ 'k004385' | translate }}
    </div>
    <div class="cantidad">
      {{ item.Valuation | trCurrency : item.Currency }}
    </div>
    <div class="beneficio">
      <div class="textito">{{ 'k004390' | translate }}
         <fa-icon
            class="ml-1 pointer blue2"
            icon="info-circle"
            (click)="viewHintHelp($event); $event.stopPropagation()"
          ></fa-icon>
      </div>
      <div>
        <div class="ben-valor">
          <span>
          {{
            item.ProfitLoss == -10000
              ? '-'
              : (item.ProfitLoss | trCurrency : item.Currency)
          }}
          </span>
          <span>({{ item.TotalProfitLossBeetweenDatesPercent | trPercentSignus }})</span>
        </div>
      </div>
    </div>
    <div class="version" *ngIf="!isMovil">
      {{ 'k003231' | translate }}:
      {{ item.ValuationDate | date : dateFormat }}
    </div>
  </div>
  <!--
  <div class="body">
    <div class="cantidad">
      {{ item.Valuation | trCurrency : item.Currency }}
    </div>
    <div class="beneficio">
      <div>
        <div class="ben-valor">
          {{
            item.ProfitLoss == -10000
              ? '-'
              : (item.ProfitLoss | trCurrency : item.Currency)
          }}
        </div>
        <div class="ben-label">{{ 'k001811' | translate }}</div>
      </div>
      <div>
        <div class="ben-valor">
          {{ item.ProfitLossPercent | trPercentSignus }}
        </div>
        <div class="ben-label">{{ 'k003230' | translate }}</div>
      </div>
    </div>
    <div class="version" *ngIf="!isMovil">
      {{ 'k003231' | translate }}:
      {{ item.ValuationDate | date : dateFormat }}
    </div>
  </div>-->
  <div class="footer" *ngIf="actionsItems.length > 0; else noData">
    <ng-container
      *ngFor="
        let action of actionsItems.slice(
          0,
          actionsItems.length > actionLimit ? actionLimit - 1 : actionLimit
        )
      "
    >
      <div class="item" *ngIf="action.visible">
        <button
          class="card"
          mat-flat-button
          (click)="clickEvent($event, action)"
        >
          <fa-icon
            *ngIf="!action.allow"
            class="warning infowarning"
            [icon]="['fas', 'exclamation-circle']"
          ></fa-icon>
          <fa-icon
            class="imgs"
            rotate="{{ action.rotate }}"
            [icon]="['fal', action.icon]"
          ></fa-icon>
        </button>
        <span class="label">{{ action.label | translate }}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="actionsItems.length > actionLimit">
      <div class="item">
        <button
          class="card"
          mat-flat-button
          *ngIf="isMovil"
          (click)="moreEvent($event, bottomSheetTemplate)"
        >
          <fa-icon
            class="imgs"
            [icon]="['fal', 'ellipsis-stroke-vertical']"
          ></fa-icon>
        </button>

        <button
          class="card"
          mat-flat-button
          *ngIf="!isMovil"
          (click)="moreEvent($event, bottomSheetTemplate)"
          [matMenuTriggerFor]="menu"
        >
          <fa-icon
            class="imgs"
            [icon]="['fal', 'ellipsis-stroke-vertical']"
          ></fa-icon>
        </button>
        <span class="label">{{ 'k001815' | translate }}</span><!--Mas-->
      </div>

      <mat-menu #menu="matMenu" xPosition="before">
        <button
          class="mini-item"
          mat-menu-item
          *ngFor="
            let action of actionsItems.slice(actionLimit-1, actionLastLimit)
          "
          (click)="clickEvent($event, action)"
        >
          <fa-icon
            class="icon"
            rotate="{{ action.rotate }}"
            [icon]="['fal', action.icon]"
          ></fa-icon>
          <span class="label">{{ action.label | translate }}</span>
          <fa-icon
            *ngIf="!action.allow"
            class="warning"
            [icon]="['fas', 'exclamation-circle']"
          ></fa-icon>
        </button>
      </mat-menu>
    </ng-container>
  </div>
</div>

<ng-template #bottomSheetTemplate>
  <div class="label-wrapper-mitem">
    <span class="label">{{ item.Alias }}</span>
    <span class="sublabel modelo"
      >{{ item.ServiceModelName ? item.ServiceModelName : '-' }}
    </span>
  </div>
  <button
    class="mini-item2"
    mat-menu-item
    *ngFor="let action of actionsItems"
    (click)="clickEvent($event, action)"
  >
    <fa-icon
      class="icon"
      rotate="{{ action.rotate }}"
      [icon]="['fal', action.icon]"
    ></fa-icon>
    <span class="label">{{ action.label | translate }}</span>
    <fa-icon
      *ngIf="!action.allow"
      class="warning"
      [icon]="['fas', 'exclamation-circle']"
    ></fa-icon>
  </button>
</ng-template>

<ng-template #noData>
  <div class="footer">{{ 'k004350' | translate }}</div>
</ng-template>
